module.exports = __webpack_public_path__ + "img/ems.0f101be3.jpg";